<template>
    <div id='budget'>
        <div class="pubw">
            <div class="head">
                <div class="h">快遞預算</div>
                <p>以實際重量來計算 <span class="weight">{{maxWeight}}</span> ，實際收費要經快遞公司量重後計算</p>
                <div class="tips">
                    <p> <span class="el-icon-warning"></span> 由於近日全球郵件流量急增，郵件處理時間會視乎情況平均增加 <span class="prompt">1-3個工作日</span> ，敬請留意。</p>
                </div>
            </div>
            <div class="body">
                <el-row type="flex">
                    <el-col :span="4" class="left">
                        <el-row class="mode">
                            <div class="t">
                                <div class="h">模式</div>
                            </div>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="mode === 0?'checkActive':''" @click="switchRadio('mode',0)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>快遞</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="mode === 1?'checkActive':''" >
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>空運</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="mode === 2?'checkActive':''" >
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>海運</p>
                            </el-col>
                        </el-row>
                        <el-row class="startShipment">
                            <div class="t">
                                <div class="h">起運港</div>
                                <div class="clear"  @click="clear('startShipment')">清除</div>
                            </div>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="startShipment === 0?'checkActive':''" >
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>HONG KANG (HKHKG)</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="startShipment === 2?'checkActive':''" >
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>HONG KANG Intl (HK)</p>
                            </el-col>
                        </el-row>
                        <el-row class="endShipment">
                            <div class="t">
                                <div class="h">目的港</div>
                                <div class="clear" @click="clear('endShipment')">清除</div>
                            </div>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="endShipment === 0?'checkActive':''" >
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>Singapore (SGSIN)</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="endShipment === 2?'checkActive':''" >
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>Changi (SIN)</p>
                            </el-col>
                        </el-row>
                        <el-row class="carrier" style="display: none;">
                            <div class="t">
                                <div class="h">承運商</div>
                                <div class="clear" @click="clear('carrier')">清除</div>
                            </div>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 0?'checkActive':''" @click="switchRadio('carrier',0)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>MSC</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 1?'checkActive':''" @click="switchRadio('carrier',1)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>Maesk</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 2?'checkActive':''" @click="switchRadio('carrier',2)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>Philippine Airlines</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 3?'checkActive':''" @click="switchRadio('carrier',3)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>Cathay Pacific</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 4?'checkActive':''" @click="switchRadio('carrier',4)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>Aramex - Express</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 5?'checkActive':''" @click="switchRadio('carrier',5)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>DHL - Express</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 6?'checkActive':''" @click="switchRadio('carrier',6)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>TNT - Express</p>
                            </el-col>
                            <el-col class="li">
                                <div class="radio">
                                    <div class="check"  :class="carrier === 7?'checkActive':''" @click="switchRadio('carrier',7)">
                                        <span class="el-icon-check"></span>
                                    </div>
                                </div>
                                <p>UPS - Express</p>
                            </el-col>
                        </el-row>
                        <el-row class="sum">
                            <div class="t">
                                <div class="h">總和</div>
                            </div>
                            <div class="num">
                                <p class="min">{{sum[0]}}</p>
                                <p class="max">{{sum[1]}}</p>
                            </div>
                            <div class="slide">
                                <el-slider
                                v-model="sum"
                                range
                                :show-tooltip="false"
                                :min="9270"
                                :max="20867"
                                >
                              </el-slider>
                            </div>
                        </el-row>
                        <el-row class="rate" style="display: none;">
                            <div class="t">
                                <div class="h">發貨頻率</div>
                            </div>
                            <div class="days">
                                <p v-for="item in rateList" :key="item.id">{{item.type}}</p>
                            </div>
                        </el-row>
                        <el-row class="etd" style="display: none;">
                            <div class="t">
                                <div class="h">ETD</div>
                                <div class="clear">清除</div>
                            </div>
                        </el-row>
                    </el-col>
                    <el-col :span="18" class="right">
                        <div class="emptyTips" v-if="routeList.length<=0">
                            路線清單為空請先選擇預算再嘗試….
                        </div>
                        <div class="route-list">
                            <div class="route" v-for="item in routeList" :key="item.routeId+item.price">
                                <div class="top">
                                    <h2 class="h">{{item.name}}</h2>
                                    <div class="percent"  v-if="item.discount != 0 && item.discount">
                                        <span>{{Math.round(Math.floor((1 -  item.discount) * 100))}}% OFF</span>
                                    </div>
                                </div>
                                <div class="middle">
                                    <div class="left">
                                        <p class="fit">{{item.fit}}</p>
                                        <p class="prescription">{{item.day}}个工作日到达</p>
                                    </div>
                                    <div class="right">
                                        <div class="up">
                                            <div class="closeHkd" v-if="item.discount !== 0 && item.discount !== 1">HKD {{item.price}}</div>
                                            <div class="hkd" v-if="item.discount !== 0 && item.discount !== 1">HKD {{item.discountPrice}}</div>
                                            <div class="hkd" v-if="item.discount == 0 || item.discount == 1">{{item.price}}</div>
                                        </div>
                                        <div class="down">
                                            <span v-text="item.taxIncluded? '包含入口税' : '不包含入口税' "></span>
                                        </div>
                                    </div>
                                </div>
                                <div class="bottom">
                                    <div class="left">
                                      <div class="characteristic">
                                          <div v-for="subitem in characteristic" :key="subitem.id" v-if="item[subitem.type]">
                                            <span class="iconfont" :class="subitem.icon" ></span>
                                            <span>{{subitem.title}}</span>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="right">
                                        <div class="on" v-if="item.statusId">
                                            <optionsButton title="预约" :callback="subscribe" :routeObj="item"/>
                                        </div>
                                        <div class="off" v-else>
                                            <optionsButton title="服务已暂停"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <!-- 禁用物品提示框 -->
        <Embargo  title="注意禁運物品" text="嚴禁寄含非食用酒精 (包括酒精紙巾及搓手液)、藥物、任何食品。如果不確定物品是否違例
請向我們查詢，違例者有可能被快遞公司罰款。" :callback="shutEmbargo" :alertShow="alertShow" p="溫馨提示
" />
    </div>
</template>

<script>
import optionsButton from '@/components/optionButton'
import Embargo from "@/components/Embargo/Embargo"
export default {
    name:'Budget',
    components:{
        optionsButton,
        Embargo
    },
    props:["maxWeight"],
    data(){
        return {
            isselect:false,
            // 模式
            mode:0,
            // 起运港
            startShipment:'',
            // 目的港
            endShipment:'',
            // 承运商
            carrier:'',
            // 总和
            sum:[9270,20867],
            // 总和数字列表
            sumMarks:[],
            // 发货频率列表
            rateList:[
                {
                    id:'6',
                    type:'日'
                },
                {
                    id:'0',
                    type:'一'
                },
                {
                    id:'1',
                    type:'二'
                },
                {
                    id:'2',
                    type:'三'
                },
                {
                    id:'3',
                    type:'四'
                },
                {
                    id:'4',
                    type:'五'
                },
                {
                    id:'5',
                    type:'六'
                }
            ],
            // 路线列表
            routeList:[
            ],
            // 路线特点
            characteristic:[
                {
                    id:'0',
                    icon:"icon-swticonkuaidi",
                    title:'上门取件',
                    type:'pickUp'
                },
                {
                    id:'1',
                    icon:"icon-daohang",
                    title:'全程挂号追踪',
                    type:'track'
                },
                {
                    id:'2',
                    icon:"icon-24gf-printer",
                    title:'需打印运单',
                    type:'print'
                },
                {
                    id:'3',
                    icon:"icon-jinzhix",
                    title:'禁止食品、液体含电池物品',
                    type:'prohibit'
                }
            ],
            // 控制禁用物品提示框的显示隐藏
            alertShow:false,
        }
    },
    methods: {
        // 监听用户点击切换单选框
        switchRadio(el,value){
            this[el]= value
        },
        // 监听用户点击清除
        clear(el){
            console.log(el)
            this[el]= ''
        },
        // 监听用户点击预约
        subscribe(params){
            this.alertShow = true
            // 把路线提交到vuex
            this.$store.commit("SETPRICE",params)
        },
        // 关闭禁用物品提示框
        shutEmbargo(type){
             this.alertShow = false
             this.$router.push('/steps')
        },
    },
    mounted() {
        this.$bus.$on("getRouteList",data=>{
            this.routeList = data
        })
        console.log("mout")
        this.alertShow = false
    },
}
</script>

<style lang="less">
    #budget{
        padding: 55px 0;
        .head{
            text-align: center;
            line-height: 50px;
            font-size:16px;
            .h{
                font-weight: 600;
                font-size: 30px;
                margin-bottom: 10px;
            }
            p{
                .weight{
                    color: @colorMain;
                    font-weight:550;
                }
            }
            .tips{
                width: 100%;
                text-align: center;
                background-color: #FFE6E2;
                border-radius: 10px;
                height: 45px;
                line-height: 45px;
                .el-icon-warning{
                    color: #F7320F;
                }
                .prompt{
                    color:#F7320F;
                }
            }
        }
        .body{
            margin-top: 40px;
            .el-row{
                justify-content: space-between;
                .left{
                    .el-row{
                        border-bottom: 2px solid #ccc;
                        padding-bottom:30px;
                        margin-bottom:30px;
                        .t{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            margin-bottom: 25px;
                            .clear{
                                font-size: 17px;
                                font-weight: 550;
                                color: @colorMain;
                                &:hover{
                                    opacity: 0.8;
                                    cursor: pointer;
                                }
                            }
                        }
                        .h{
                            font-weight: 600;
                            font-size: 17px;
                        }
                        .li{
                            display: flex;
                            align-items: center;
                            line-height: 40px;
                            .radio{
                                display: flex;
                                .check{
                                    display: flex;
                                    width: 25px;
                                    height: 25px;
                                    border:1px solid #ccc;
                                    border-radius:50%;
                                    margin-right:10px;
                                    align-items: center;
                                    justify-content: center;
                                    &:hover{
                                        cursor: pointer;
                                        opacity: .8;
                                    }
                                    span{
                                        display: none;
                                    }
                                }
                                .check.checkActive{
                                    background-color: @colorMain;
                                    border:1px solid @colorMain;
                                    color: #fff;
                                    span{
                                        display:block;
                                    }
                                }
                            }
                            p{
                                font-weight: 550;
                                font-size: 17px;
                                white-space: nowrap;
                            }
                        }
                    }
                    .el-row:last-child{
                        border-bottom: none;
                        padding-bottom:0px;
                        margin-bottom:0px;
                    }
                    .sum{
                        .num{
                            display: flex;
                            justify-content: space-between;
                            align-items: center;
                            p{
                                font-size: 17px;
                                font-weight: 600;
                            }
                        }
                        .slide{
                            .el-slider__bar{
                                background-color: @colorMain;
                            }
                            .el-slider__button{
                                border-color: @colorMain;
                            }
                        }
                    }
                    .rate{
                        .days{
                            display: flex;
                            justify-content:space-between;
                            align-content:center;
                            p{
                                background-color: @colorMain;
                                width: 25px;
                                height: 25px;
                                text-align:center;
                                line-height:25px;
                                color:#fff;
                                border-radius:5px;
                            }
                        }
                    }
                }
                .right{
                    .route-list{
                        .route{
                            /* height: 235px; */
                            background-color:#fff;
                            box-shadow:1px 3px 6px #ccc;
                            border-radius:15px;
                            padding:30px 20px;
                            margin-bottom:30px;
                            .top{
                                display: flex;
                                justify-content: space-between;
                                .h{
                                    font-size: 23px;
                                    font-weight:600;
                                }
                                .percent{
                                    background-color: #e22a2a;
                                    width: 100px;
                                    height: 26px;
                                    border-radius:20px;
                                    text-align:center;
                                    line-height:26px;
                                    color:#fff;
                                }
                            }
                            .middle{
                                display: flex;
                                margin: 20px 0;
                                .left,
                                .right{
                                    display:flex;
                                }
                                .left{
                                    width: 38%;
                                    justify-content: space-between;
                                    font-size: 17px;
                                }
                                .right{
                                    width: 62%;
                                    justify-content: flex-end;
                                    flex-wrap: wrap;
                                    .up{
                                        display: flex;
                                        margin-bottom:15px;
                                        .closeHkd{
                                            text-decoration:line-through;
                                            margin-right:15px;
                                        }
                                        .hkd{
                                            font-size: 30px;
                                            font-weight: 600;
                                        }
                                    }
                                    .down{
                                        width: 100%;
                                        text-align: end;
                                    }
                                }
                            }
                            .bottom{
                                display: flex;
                                .right,.left{
                                    display: flex;
                                    width: 50%;
                                }
                                .left{
                                    .characteristic{
                                        display: flex;
                                        flex-wrap:wrap;
                                        line-height:35px;
                                        div{
                                            display: flex;
                                            align-items: center;
                                            white-space: nowrap;
                                            width: 50%;
                                            font-size: 15px;
                                            .iconfont{
                                                margin-right: 5px;
                                                font-size:25px;
                                            }
                                            .icon-jinzhix{
                                                color: #F7320F;
                                            }
                                        }
                                    }
                                }
                                .right{
                                    justify-content: flex-end;
                                    .on,.off{
                                        width: 188px;
                                        height: 56px;
                                        button{
                                            width: 100%;
                                            height: 100%;
                                        }
                                    }
                                    .off{
                                        button{
                                            color: #868686;
                                            background-color: #F2F2F2;
                                            &:hover{
                                                opacity: 1;
                                                cursor: default;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
</style>